<template>
  <section id="aboutme">
    <div
      class="d-flex flex-column align-items-center justify-content-center"
      style="
        background: linear-gradient(
          to bottom,
          rgb(52 144 103 / 90%),
          rgb(242, 242, 242),
          rgb(219, 219, 219),
          rgb(234, 234, 234)
        );
        padding: 200px 0px 150px;
      "
    >
      <h4 style="font-size: 30px; font-family: 'Poppins', sans-serif">
        About
        <span style="color: #42b983">Me</span>
      </h4>
      <b-img
        rounded="circle"
        alt="Circle image"
        src="yo.png"
        width="250"
        height="250"
        class="m-4"
        style="border: 4px solid #42b983"
      ></b-img>
      <div class="text-overline mt-4 m-auto w-75">
        With two degrees as
        <b>Programmer Analyst</b> and <b>Information Systems Analyst</b> I
        gained knowledge about <b>user interface</b>, <b>testing</b> and
        <b>debugging processes</b>. Giving birth experience in design,
        installation, testing and maintenance of web/mobile systems. Equipped
        with a diverse and promising skill set. Able to effectively
        <b>self-manage during independent projects</b>, as well as collaborate
        in a team environment.
      </div>
      <div class="m-5">
        <a
          href="./Valentino Indovino Bustos - Resume - 2025.pdf"
          download
          class="btn-resume m-4"
          style="text-decoration: none; color: white"
          id="mystack"
        >
          Download Resume
        </a>
      </div>
    </div>
  </section>
</template>

<style>
.btn-resume {
  border-radius: 10px;
  padding: 15px 30px;
  font-size: 15px;
  font-weight: bold;
  background: linear-gradient(to left, #42b983 50%, #e4e4e4 50%) right;
  background-size: 200%;
  transition: 0.3s ease-out;
}
.btn-resume:hover {
  background-position: left;
  color: #42b983 !important;
  border: 1px solid #42b983;
}
</style>
